import { ConfigService } from "../config/config.service";
import { Injectable } from "@angular/core";
import { UserSessionService } from "../user-session/user-session.service";
import { Platform } from '@ionic/angular';
import { Navigator } from "src/app/services/routing/navigator";
import { GoogleGeoService } from "../google-geocheck";
import { HttpClient } from "@angular/common/http";
import { Geolocation } from '@capacitor/geolocation';
import { EventsService } from "../event/event.service";
import { WebservicesService } from "../webservices/webservices.service";
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { JurisdictionService } from "../geo/jurisdiction.service";
import { toBoolean } from "../codeUtils";
import { GeoLocationStrategyService } from "../geo-location-strategy/geo-location-strategy.service";
import { GeoLocationControllerService } from "../geo-location/geo-location-controller.service";
import { GeoLocationPreRequestService } from "../geo-location/geo-location-pre-request.service";
import { GeoLocationSDKInitService } from "../geo-location/geo-location-sdkinit.service";

@Injectable()
export class LocationWarningService {

  public onLandingPage: boolean;
  public onJoin: boolean;
  public  afterSuccessfulRegistration: boolean;
  currentContext: string = '';
  params: any = {};
  shouldRestrictPlayer: boolean;

  androidIpGeoCheck = true;
  private errorObject: any = null;
  private geoEnforcedCheck = false;
  private lastGeoResponse: any;

  private initTriggeredBy;
  locationWarningCheck: boolean;
  private isNotAndroidApp:boolean = false;
  isAndroidApp: boolean;

  constructor(
    private config: ConfigService,
    private userSessionService: UserSessionService,
    private Lnavigator: Navigator,
    private platform: Platform,
    private googleGeoService: GoogleGeoService,
    private http: HttpClient,
    private webservices: WebservicesService,
    private eventsService: EventsService,
    private geoLocationControllerService: GeoLocationControllerService,
    private geoLocationStrategyService: GeoLocationStrategyService,
    private geoLocationPreRequestService: GeoLocationPreRequestService,
    private geoLocationSDKInitService: GeoLocationSDKInitService,
    private jurisdiction: JurisdictionService
  ) {
    this.onJoin = this.config.getConfig().FEATURE_LOCATION_WARNING_ON_JOIN === "1" ? true : false;
    this.afterSuccessfulRegistration = this.config.getConfig().FEATURE_LOCATION_WARNING_AFTER_REGISTERATION === "1" ? true : false;
    this.onLandingPage = this.config.getConfig().FEATURE_LOCATION_WARNING_ON_LANDING_PAGE === "1" ? true : false;
    this.locationWarningCheck = this.config.getConfig().FEATURE_LOCATION_WARNING_CHECK === "1" ? true : false;

    this.androidIpGeoCheck = this.config.getConfig()?.FEATURE_ANDROID_IPGEOCHECK == 'true' || true;

    this.eventsService.subscribe('event:appInit:init', (params) => {
      this.initTriggeredBy = !!params && !!params.triggeredBy ? params.triggeredBy : '';
    });

    this.isAndroidApp = this.platform.is('android') && this.platform.is('capacitor');
    if(!this.isAndroidApp){
      this.initGeoVerificationProcess();
    }
  }

  createErrorObject(code = "", message = "") {
    return {
      error: {
        error_code: code,
        error_message: message,
        address: null,
        is_allowed: false,
      },
    };
  }


  public async initGeoVerificationProcess() {
    if (this.locationWarningCheck) {
     console.log('--------- LOCATION WARNING------------');
     this.geoEnforcedCheck =
        this.config.getConfig()?.GEOENFORCED == "true" ?? true;
          await new Promise((resolve, reject) => {
        try {
          this.getDeviceLocation();
          resolve(1);
        } catch (error) {
          if (error) console.error(error);
          if (!this.platform.is("capacitor") && error.code == "1") {
            this.errorObject = this.createErrorObject(
              "GOOGLEGEOUSERERROR",
              "User denied location permission"
            );
          } else if (this.platform.is("capacitor") && error.code == "2") {
            this.errorObject = this.createErrorObject(
              "GOOGLEGEOERROR",
              "Location Permission Denied"
            );
          } else {
            this.errorObject = this.createErrorObject(
              "GOOGLEGEOERROR",
              "Geolocation not available"
            );
          }
          console.log("Google Geo Error", this.errorObject.error);
          reject(this.errorObject);
        }
      });
    }
  }

   private async getDeviceLocation() {
    if (this.platform.is("capacitor") || this.platform.is("cordova")) {
      if (this.platform.is('android')) {
        //Geo-Optimized Logic for Android
        if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
          if(this.geoLocationPreRequestService.shouldDisplayPermissionReason()){
            this.geoLocationPreRequestService.displayPermissionReason().then(async (acceptsReason: any) => {
             console.log('******acceptsReason******', acceptsReason)
             if (acceptsReason && "data" in acceptsReason && acceptsReason.data) {
              console.log("Requesting native permissions")
              const initGeoComply = await this.geoLocationSDKInitService.initializeGeoComplyForMobileApp();
              if (initGeoComply) {
                //const geoComplyClient = this.geoLocationSDKInitService.getGeoComplyWindowClient();
                this.geoLocationControllerService.requestRuntimePermissions(
                  async () => {
                    this.geoLocationPreRequestService.setAcceptReason(true);
                    //Below Function sets the logic to display Location Warning popup
                    const coords = await Geolocation.getCurrentPosition();
                    return this.verifyGeolocation(coords.coords);
                  },
                  (deny) => {
                    console.log("Android geo ", deny);
                    return this.openAppRestrctionPage();
                  }
                );
              }
            } else {
                this.openAppRestrctionPage();
              }
            })
          } else {
            return await this.getMobileLocation();
          }
        } else {
          //NON Geo-Optimized Logic for Android
          if (this.jurisdiction.shouldDisplayPermissionReason()) {
            this.jurisdiction.displayPermissionReason().then(async (acceptsReason: any) => {
              this.jurisdiction._didUserAcceptReason = acceptsReason;
              if (acceptsReason && "data" in acceptsReason && acceptsReason.data) {
                return await this.getMobileLocation();
              } else {
                this.openAppRestrctionPage();
              }
            })
          } else {
            return await this.getMobileLocation();
          }
        } 
      } else {
        //iOS App
        return await this.getMobileLocation();
      }
    }else {
        //Web Application
        return await this.getWebLocation();
    }
  }

  private async getMobileLocation() {
    try {
      const permissions = await Geolocation.requestPermissions();
      if (permissions.location !== "granted") {
        if(!this.isNotAndroidApp){
          this.openAppRestrctionPage(); 
        } 
          throw { code: "2", message: "Location Permission Denied" };
      } else {
        this.jurisdiction.setAcceptReason(true);
      }

      const coords = await Geolocation.getCurrentPosition();
      return this.verifyGeolocation(coords.coords);
    } catch (error) {
      throw error;
    }
  }

  private openAppRestrctionPage(){
    return this.Lnavigator.navigateTo("AppRestrictedComponent", {
      customModalClass: "app-restricted-screen",
      animated: false,
    });
  }

  private async getWebLocation() {
    if (navigator.geolocation) {
      try {
        const position: {
          coords: {
            latitude: number;
            longitude: number;
          };
        } = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          });
        });

        if (position?.coords) {
          return this.verifyGeolocation(position?.coords);
        } else {
          throw Error("Geolocation not available");
        }
      } catch (error) {
        console.log(error);

        // throw error;
      }
    } else {
      return Error("Geolocation not available");
    }
  }

  public verifyGeolocation(coords): void {
    const { latitude, longitude } = coords;

    this.postGeolocationData(
      latitude,
      longitude
    );
  }

  private postGeolocationData(
    latitude: number,
    longitude: number
  ): void {
    const postData = {
      clientapp: this.config.getClientApp(),
      data: this.getPositionJSON({ latitude, longitude })

    };

    this.webservices.post("geolocation/boundary-check", postData).subscribe({
      next: (response: any) => {
        console.log("GeoResponse", response);
        if (response.result === 1) {
          this.lastGeoResponse = response?.payload?.geo_result;
          if (
            (response.payload &&
              response.payload.geo_result.is_within_border == true) ||
            (this.geoEnforcedCheck &&
              response.payload.geo_result.geolocation_enforced == true)
          ) {
            this.shouldRestrictPlayer = false;
            // return this.handleGeolocationWithinBorder();
          } else if (
            response.payload &&
            response.payload.geo_result.is_allowed == false
          ) {
            this.shouldRestrictPlayer = true;
            console.error("Location not allowed. Sending error response.");
            this.errorObject = {
              ...this.createErrorObject(
                "GOOGLEGEOBOUNDARYERROR",
                "Location not allowed. Sending error response."
              ),
              ...response.payload?.geo_result,
            };
            this.openLocationWarning('landing',  {  multipleModals: true });
            console.log(
              "Location Not Allowed Sending GeoResponse",
              this.errorObject.error
            );
          } else {
            console.log(
              "Location Allowed Sending GeoResponse",
              response?.payload?.geo_result
            );

            // this._jurisdictionSubject.next(response?.payload?.geo_result);
          }
        } else {
          console.error("Unexpected response result:", response.result);
        }
      },
      error: (error) => {
        this.errorObject = this.createErrorObject("GOOGLEGEOERROR", error);
      },
    });
  }


  public locationIsAllowed() :boolean {
    return !this.shouldRestrictPlayer;
  }

  public getParams() {
    return this.params;
  }

  public getCurrentContext() {
    return this.currentContext;
  }

  public openLocationWarning(point, params?) {
    this.currentContext = point;
    if ((Object.entries(params).length !== 0)) {
      this.params = params;
    }
    switch (point) {
      case 'join':
        {
          if (this.onJoin) {
            this.Lnavigator.navigateTo("LocationWarningComponent", {  multipleModals: true });
          }
          break;
        }
      case 'register':
        {
          if (this.afterSuccessfulRegistration) {
            this.Lnavigator.navigateTo("LocationWarningComponent",  {  multipleModals: true }, { callBackFn: () => { this.addGeoAfterLogin() } });
          }
          break;
        }
      case 'landing':
        {
          if (this.onLandingPage && this.initTriggeredBy !== "REFRESH" &&  sessionStorage.getItem('locationWarningSeenByUser') === null) {
            this.Lnavigator.navigateTo("LocationWarningComponent", {  multipleModals: true });
          }
          break;
        }
    }
  }

  public customerNotActive() {
    let result = false;
    this.userSessionService.getCustomer().subscribe(customer => {
      if (!!customer) {
        result = customer.status.toLowerCase() === 'active' ? false : true;
      }
    })
    return result;
  };

  private addGeoAfterLogin = () => {
		const config = this.config.getConfig();
		const geoAfterLoginFlag: boolean = this.config.isFeatureON( config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', false);
    if (geoAfterLoginFlag) {
      if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
        this.geoLocationControllerService.executeGeoLocationProcess()
          .then((geoResp: GeoResponse) => {
            if (geoResp.is_allowed) {
              return console.log('geo check passed');
            } else {
              console.log('geo check failed');
            }
          }).catch((err) => {
            console.log("addGeoAfterLogin: launch aborted.", err);
          });
      } else {
        this.jurisdiction
        .verifyJurisdiction(() => { })
        .then((geoResp: GeoResponse) => {
          console.log('Signup Result geo check');
        })
        .catch((err) => {
          console.log("Signup Result: launch aborted.", err);
        });
      }
    }
  }

  addGeo = () => {
    if (this.config.getConfig().FEATURE_GEOLOCATION_ENFORCED && this.customerNotActive() === false) {
      console.log('Signup Result: launch geo check started');
      this.googleGeoService.initGeoVerificationProcess()
        .then(() => {
          console.log('Signup Result geo check');
        })
        .catch((err) => {
          console.log("Signup Result: launch aborted.", err);
        });
    }

  }
  private getPositionJSON(position: {
    latitude: number;
    longitude: number;
  }): string {
    return JSON.stringify({
      coords: {
        latitude: position.latitude,
        longitude: position.longitude,
      },
    });
  }


}
